import React from 'react';
import SalesEstimateListContainer from '../../containers/sales_estimate/SalesEstimateListContainer';

const SalesEstimateListPage = () => {
  return <SalesEstimateListContainer />;
};

export default SalesEstimateListPage;
